import { Box } from '@mui/material';
import React, { FC } from 'react';
import classNames from 'classnames';
import { IconDot, IconHorizontalDot } from '../../utils/icons';

interface Props {
  id: string;
  isDetailedPage?: boolean;
  element?: HTMLElement | null;
  onClick?: (event: HTMLElement) => void;
}

export const MenuIcon: FC<Props> = ({
  element,
  id,
  isDetailedPage,
  onClick,
}) => (
  <Box
    className='flex items-center justify-center'
    onClick={(event) => onClick?.(event.currentTarget)}
    id={id}
    aria-controls={element ? 'single-embed-menu' : undefined}
    aria-haspopup='true'
    aria-expanded={element ? 'true' : undefined}
  >
    <Box
      className={classNames(
        'flex items-center justify-center cursor-pointer border border-transparent hover:bg-surface-2 hover:border-muted',
        {
          'p-2 !bg-surface-2 rounded-lg': isDetailedPage,
          'p-1 rounded-md': !isDetailedPage,
          '!bg-surface-2 !border-muted': !!element,
        },
      )}
    >
      {isDetailedPage ? <IconHorizontalDot /> : <IconDot />}
    </Box>
  </Box>
);
